var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('span',{staticClass:"printUserWrapper"},[(_vm.user.vorname && _vm.user.nachname)?_c('span',[_vm._v(" "+_vm._s(_vm.user.vorname)+" "+_vm._s(_vm.user.nachname)+" ")]):(_vm.user.nachname)?_c('span',[_vm._v(" "+_vm._s(_vm.user.nachname)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.user.username)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }